

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface stateProps {
    nombres?:                string;
    apellidos?:              string;
    correoElectronico?:      string;
    token?:                  string;
    autoridad?:              string;
    administrador?:          boolean;
    restablecerContrasena?:  boolean;
}

const initialState: stateProps = {
    token: '',
    nombres: '', 
    apellidos: '', 
    correoElectronico: '', 
    autoridad: '',
    administrador: false,
    restablecerContrasena: false,
} as stateProps;

export const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        login: ( state, { payload } : PayloadAction<stateProps> ) => {
            state.token = payload.token;
            state.nombres = payload.nombres;
            state.apellidos = payload.apellidos;
            state.correoElectronico = payload.correoElectronico; 
            state.autoridad = payload.autoridad; 
            state.administrador = payload.administrador; 
            state.restablecerContrasena = payload.restablecerContrasena; 
        },
        logout: ( state ) => {     
            state.token = '';
            state.nombres = '';
            state.apellidos = '';
            state.correoElectronico = '';        
            state.autoridad = '';        
            state.administrador = false;          
            state.restablecerContrasena = false;          
        },
    },
})

export const { login, logout } = authSlice.actions

export default authSlice.reducer